import React from 'react';
import './ContabilidadInfo.css';

const ContabilidadInfo = ({ fecha, datos, datosMes, cargando, error }) => {
  if (cargando) return <div className="alert alert-info">Cargando datos...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!datos) return <div>Selecciona una fecha para ver los datos.</div>;

  const { fecha: fechaStr, total_dia, total_tarjeta, total_efectivo } = datos;

  // Extraemos el primer elemento del array datosMes o null si no existe
  const mesInfo = datosMes && datosMes.length > 0 ? datosMes[0] : null;

  return (
    <div className="contabilidad-info">
      <h4>Resumen del día: {fechaStr}</h4>

      <div className="row">
        <div className="col-md-4">
          <div className="card text-white bg-primary mb-3 contabilidad-card">
            <div className="card-header">Total del día</div>
            <div className="card-body">
              <h5 className="card-title">€{parseFloat(total_dia).toFixed(2)}</h5>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-white bg-success mb-3 contabilidad-card">
            <div className="card-header">Total con Tarjeta</div>
            <div className="card-body">
              <h5 className="card-title">€{parseFloat(total_tarjeta).toFixed(2)}</h5>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-white bg-warning mb-3 contabilidad-card">
            <div className="card-header">Total en Efectivo</div>
            <div className="card-body">
              <h5 className="card-title">€{parseFloat(total_efectivo).toFixed(2)}</h5>
            </div>
          </div>
        </div>
      </div>

      {/* Total del mes */}
      {mesInfo && (
        <div className="card text-white bg-dark mb-3 contabilidad-card mt-3">
          <div className="card-header">
            Total del mes: {mesInfo.nombre_mes} {mesInfo.año}
          </div>
          <div className="card-body">
            <h5 className="card-title">€{parseFloat(mesInfo.total_mes).toFixed(2)}</h5>
          </div>
        </div>
      )}
    </div>
  );
};



export default ContabilidadInfo;
